import {Button, Drawer, DrawerProps, Table} from 'antd';
import Style from './index.module.scss';
import type {ColumnsType} from 'antd/es/table';
import {useMutation, useQuery} from 'react-query';
import {AgentDataSet} from '../../../agentDataSetService';
import useSelection from 'Utils/Hooks/useSelection';
import React from 'react';

interface Props extends DrawerProps {
    agentId: string;
    onOk: () => void;
}

const Index = ({agentId, onOk, ...props}: Props) => {
    const rowSelection = useSelection<AgentDataSet.List>();

    const getData = useQuery({
        queryKey: ['DataSetFunction.options', agentId],
        queryFn: () => AgentDataSet.options({agentId}),
    });

    const onSave = useMutation({
        mutationFn: AgentDataSet.save,
        onSuccess: () => {
            onOk();
        },
    });

    const columns: ColumnsType<AgentDataSet.List> = [
        {
            title: '数据集 名称',
            dataIndex: 'name',
        },
        {
            title: '数据集 Code',
            dataIndex: 'code',
        },
        {
            title: 'RAGFlow 数据集ID',
            dataIndex: 'externalId',
        },
    ];

    function onFinish() {
        onSave.mutate({
            agentId,
            data: rowSelection.selectedRows.map(item => {
                const {createdAt, updatedAt, ...rest} = item;
                rest.priority = 0;
                rest.enabled = true;
                return rest;
            }),
        });
    }

    function Extra() {
        return (
            <Button type="primary" onClick={onFinish}>
                保存
            </Button>
        );
    }

    return (
        <Drawer
            title="选择数据集"
            width="800"
            className={Style.root}
            extra={<Extra />}
            {...props}>
            <Table
                rowKey="id"
                bordered
                size="small"
                columns={columns}
                dataSource={getData.data}
                loading={getData.isLoading || onSave.isLoading}
                scroll={{x: 'max-content'}}
                pagination={false}
                rowSelection={rowSelection}
            />
        </Drawer>
    );
};

export default Index;
